angular.module('elogbooksServices').service('requestAttachment', function($filter) {

    this.getAll = getAll;
    this.getName = getName;

    var options = [
        { value: true, name: $filter('translate')("REQUEST_ATTACHMENT"), title: $filter('translate')("REQUEST_ATTACHMENT") },
        { value: false, name: $filter('translate')("NO_ATTACHMENT"), title: $filter('translate')("NO_ATTACHMENT") },
    ];

    function getAll() {
        return options;
    }

    function getName(value) {
        if(value === true) {
            return options[0].name;
        }
        else if (value === false) {
            return options[1].name;
        }

        return null;
    }

    return this;
});
